import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../i18n/router';
import useAPIError from '../../hooks/useAPIError';
import DataService from '../../services/MisDatosService';
import { ErrorCodeConstants } from '../../utils/ErrorCodeConstants';
import { TextHelper } from '../../utils/TextHelper';
import ModalConfirmacion from '../../components/ModalConfirmacion';
import ModalRecuperarPass from './forms/ModalRecuperarPass';
import { PrefijoPais } from '../../types/PersonalData';
import { useAppStore } from '../../store/AppContext';
import { SessionChecker } from '../../utils/SessionChecker';
import { StorageHelper } from '../../utils/StorageHelper';
import { FrontMappings } from '../../utils/FrontMappings';
import { useMisDatosStore } from './context/MisDatos.context';

interface Props {
  startService: boolean;
  setStartSmsService: (start: boolean) => void;
  opcion: string;
  setShowPersonalData: (show: boolean) => void;
  prefijosPaises: PrefijoPais[];
  cargarPersonalData: () => void;
  cargarAccessData: () => void;
  prefijoPersonalData?: string;
  telefonoPersonalData?: string;
  setShowOroError?: (show: boolean) => void;
  origenData: string;
}

const ServicioSms: FC<Props> = (props) => {
  const {
    startService,
    setStartSmsService,
    opcion,
    setShowPersonalData,
    prefijosPaises,
    cargarPersonalData,
    cargarAccessData,
    prefijoPersonalData,
    telefonoPersonalData,
    setShowOroError,
    origenData,
  } = props;

  const { t } = useTranslation();
  const dataApp = useAppStore();
  const {
    showModalTelefono1,
    showModalContactEmail,
    showFlagTelefono1Incorrecto,
  } = useMisDatosStore();
  const { lang } = dataApp;
  const [showRecuperar, setShowRecuperar] = useState(false);
  const { addError } = useAPIError();
  const [errorType, setErrorType] = useState(0 as number);
  const [showError, setShowError] = useState(false);
  const [titleError, setTitleError] = useState('' as string);
  const [messageError, setMessageError] = useState('' as string);
  const errorAcceptButtonText = t('entendido');

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {
    setErrorType(0);
  };

  const acceptError = () => {
    setShowError(false);
    console.log(opcion);
    if (
      errorType ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
    ) {
      if (origenData === 'oro') {
        StorageHelper.setOpenOroPersonalData();
        window.location.href = routerLoader.LoadRouterByPath(
          FrontMappings.MISDATOS,
          dataApp.lang,
        );
      } else {
        setShowPersonalData(true);
        StorageHelper.setOpenV2pPersonalData();
      }
    } else if (
      errorType ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
    ) {
      const formDireccion = document.querySelector(
        '[id^="habitual-"]',
      ) as HTMLFormElement;
      if (formDireccion) {
        formDireccion.classList.add('visible');
        const submitButtons = document.querySelectorAll(
          '[id^="direccion-submit-btn-"]',
        );
        const button = submitButtons[0] as HTMLElement;
        button.click();
      }
      sessionStorage.setItem('showDireccion', '1');
      setErrorType(0);
    } else if (
      errorType ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
    ) {
      showModalTelefono1();
      showFlagTelefono1Incorrecto();
      setErrorType(0);
    } else if (
      errorType ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
    ) {
      showModalContactEmail();
      setErrorType(0);
    }
  };

  useEffect(() => {
    if (startService) {
      DataService.checkPrevalidacionDatos()
        .then((response) => {
          if (response?.data?.error) {
            setTitleError(
              t(TextHelper.getErrorTitleKeyTransformed(response.data.title)),
            );
            setMessageError(
              t(
                TextHelper.getErrorMessageKeyTransformed(
                  response.data.userMessage,
                ),
              ),
            );
            setErrorType(response.data.errorCode);
            if (
              response?.data?.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
            ) {
              setShowError(true);
            }
          } else {
            setShowRecuperar(true);
          }
        })
        .catch((er: any) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
      setStartSmsService(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startService]);

  useEffect(() => {
    if (errorType === ErrorCodeConstants.EMPTY_TOKEN_EXCEPTION) {
      SessionChecker.closeSessionAndGoToReLogin('misdatos', lang);
    } else if (
      errorType === ErrorCodeConstants.NO_USER_IN_SESSION_EXCEPTION ||
      errorType === ErrorCodeConstants.DISTINCT_USER
    ) {
      setShowError(true);
    } else if (
      errorType ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION ||
      errorType ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION ||
      errorType ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION ||
      errorType ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
    ) {
      setShowError(true);
      cargarAccessData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorType]);

  return (
    <>
      <ModalRecuperarPass
        visible={showRecuperar}
        setVisibleVerificacionDoble={setShowPersonalData}
        setVisible={setShowRecuperar}
        cargarPersonalData={cargarPersonalData}
        cargarAccessData={cargarAccessData}
        opcion={opcion}
        prefijosPaises={prefijosPaises}
        prefijoPersonalData={prefijoPersonalData}
        telefonoPersonalData={telefonoPersonalData}
        setShowOroError={setShowOroError}
      />
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showError}
        setShowModal={setShowError}
        title={t(titleError)}
        textHTMLContent={t(messageError)}
        doAceptar={acceptError}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={errorAcceptButtonText}
      />
    </>
  );
};

export default ServicioSms;
